/** コース名（terms[].name）の最大文字数 — API Create/Update と一致 */
export const GRADUATION_GROUP_NAME_MAX_LENGTH = 50;

export const graduationStatus = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  CLOSED: 'CLOSED',
};

/** Only admin-created lessons can be granted to a course (BE: created_type=ADMIN). */
export const LESSON_CREATED_TYPE = {
  ADMIN: 'ADMIN',
  TEACHER: 'TEACHER',
};

/**
 * Course permission validation codes returned by the BE FormRequest (HTTP 422).
 * The BE deliberately ships no message for these rules, so the wording lives here.
 * The two business rules thrown as HTTP 400 (GRADUATION-46 not_admin_lesson,
 * GRADUATION-47 unit_limit_exceed_total) already carry a localized BE message and
 * are handled by the generic fallback instead.
 */
export const COURSE_PERMISSION_ERROR_MESSAGE_KEY: Record<string, string> = {
  'MFS-E-LEARNING-ADMIN-GRADUATION-42': 'graduation.lesson_error.lessons_invalid',
  'MFS-E-LEARNING-ADMIN-GRADUATION-43': 'graduation.lesson_error.lesson_id_required',
  'MFS-E-LEARNING-ADMIN-GRADUATION-44': 'graduation.lesson_error.is_shared_required',
  'MFS-E-LEARNING-ADMIN-GRADUATION-45': 'graduation.lesson_error.unit_limit_min',
  'MFS-E-LEARNING-ADMIN-GRADUATION-48': 'graduation.lesson_error.lesson_id_duplicated',
  'MFS-E-LEARNING-ADMIN-GRADUATION-49': 'graduation.lesson_error.is_available_required',
};
